import { useCallback, useEffect } from "react";
import useFetchProfile from "src/hooks/api/useFetchProfile";
import useAuth from "src/hooks/selectors/useAuth";
import { listen } from "src/lib/socket";

export default function useApiSockets() {
	const auth = useAuth();
	const { fetchProfile } = useFetchProfile();

	const init = useCallback(() => {
		if (auth.id) {
			listen(`profile-changed.${auth.hid}`, () => {
				fetchProfile();
			});
		}
	}, [auth, fetchProfile]);

	useEffect(() => {
		init();
	}, [init]);
}
